export default __webpack_public_path__ + "static/media/backoffice-banner.636d4e44.webp";